import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaCode, FaGraduationCap, FaProjectDiagram, FaEnvelope } from 'react-icons/fa';

const Navigation = () => {
    const navItems = [
        { path: '/', label: 'Home', icon: <FaHome /> },
        { path: '/skills', label: 'Skills', icon: <FaCode /> },
        { path: '/experience', label: 'Experience', icon: <FaGraduationCap /> },
        { path: '/projects', label: 'Projects', icon: <FaProjectDiagram /> },
        { path: '/contact', label: 'Contact', icon: <FaEnvelope /> }
    ];

    return (
        <nav className="main-navigation">
            <ul className="nav-links">
                {navItems.map((item, index) => (
                    <li key={index}>
                        <NavLink
                            to={item.path}
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                        >
                            <span className="nav-icon">{item.icon}</span>
                            <span className="nav-label">{item.label}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Navigation;
